export default __webpack_public_path__ + "static/media/reports.e9890611.svg";